import React, { useState, useEffect } from "react";
import { navigate } from "gatsby";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import Button from "../../atoms/button/button";
import PodcastsSlider from "../../molecules/podcasts-slider/podcastsSlider";

import "./podcastsRotator.scss";

const PodcastsRotator = (props: ReferenciaContenido) => {
  const [data, setData] = useState<any>([]);
  const [render, setRender] = useState(0);

  const fetchPodcasts = async () => {
    if (render != 0) {
      return;
    }

    if (props.tipoLibro !== "podcast") {
      setRender(1);
      const req = await fetch(
        `${process.env.CONTENTLOAN_API_URL}/search/api/v1/filter?limit=14&page=0&contentType=Collection%20podcast&order=DATE`
      );
      const podcasts = await req.json();

      setData(podcasts.data.filter);
    } else {
      setRender(1);
      const req = await fetch(
        `${process.env.CONTENTLOAN_API_URL}/search/api/v1/filter?limit=14&page=0&contentType=podcast&collection=${props.autoresArticulo}&order=DATE`
      );
      const episodes = await req.json();
      setData([...episodes.data.filter]);
    }
  };

  const navigatePodcast = () => {
    navigate(`/ver-todo/?title=${props.tituloGeneral}` +
    `&searchType=filter` +
    `&contentType=Collection Podcast` + 
    `&searchParam=word,contentType` +
    `&paramValues=/-Collection podcast/-/-/-DATE`,
     {
      state: {},
    });
  };

  const navigateCollection = () => {
    navigate(`/ver-todo/?title=${props.tituloGeneral}` +
    `&searchType=filter` +
    `&contentType=Collection Podcast` + 
    `&searchParam=word,contentType` +
    `&paramValues=/-podcast/-/-${props.autoresArticulo}/-DATE`,
    {
      state: {},
    });
  };

  useEffect(() => {
    fetchPodcasts();
  }, []);

  fetchPodcasts();

  return (
    <div className="o-podcasts-rotator">
      <div className="o-podcasts-rotator__upper">
        <h2 className="o-podcasts-rotator__upper-title">
          {props.tituloGeneral}
        </h2>
        {data.length > 5 && (
          <Button
            classname="o-podcasts-rotator__upper-btn"
            type="button"
            text="VER TODO"
            isDisabled={false}
            onClickAction={
              props.tipoLibro !== "podcast"
                ? navigatePodcast
                : navigateCollection
            }
            gtmMark={`gtm${normalizeTwoWords(
              props.nombreCategoria
            )}${normalizeTwoWords(props.tituloGeneral)}VerTodo`}
          />
        )}
      </div>

      <div className="o-podcasts-rotator__content">
        {data.length > 0 ? (
          <PodcastsSlider
            podcasts={data}
            gtmClass={`${normalizeTwoWords(
              props.nombreCategoria
            )}${normalizeTwoWords(props.tituloGeneral)}`}
          />
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
};

export default PodcastsRotator;
